import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
import { Point } from "pixi.js";
export class FreeSpinsRainbowOverlayProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    setDefaultValues() {
        this.overlayProperties = new SpineProperties("FreeSpinsReel", "Game", new Point(973, 512));
    }
    equals(other) {
        return this.overlayProperties.equals(other.overlayProperties);
    }
}
//# sourceMappingURL=FreeSpinsRainbowOverlayProperties.js.map